import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Icon,
  Label,
  Segment,
} from 'semantic-ui-react';
import React from 'react';
import { Col, Row, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import COLORS from '../../constants/colors';

const Ecna = ({ cnaData }) => {
  const { grade_level: gradeLevel, key_need_l1: keyNeedL1, school_board: schoolBoard } = cnaData || {};
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  if (!cnaData || (cnaData && Object.keys(cnaData)?.length === 0)) {
    return null;
  }

  return (
    <Segment>
      <Accordion>
        <AccordionTitle active={activeIndex === 0} index={0} onClick={handleClick}>
          <Row alignItems="center" justifyContent="space-between">
            <Col>
              <Text variant="body1Medium">Customer Needs</Text>
            </Col>
            <Col>
              <Icon name="dropdown" />
            </Col>
          </Row>
        </AccordionTitle>
        <AccordionContent active={activeIndex === 0}>
          <Col gutter={12} gap={8}>
            <Text variant="eyebrow2" color={COLORS.GRAY}>
              Math Level
            </Text>
            <Text variant="body1Medium">{gradeLevel}</Text>
            <Separator height={16} transparent />
            <Text variant="eyebrow2" color={COLORS.GRAY}>
              Learning Goals
            </Text>
            <Separator height={4} transparent />
            {keyNeedL1?.map(keyNeed => (
              <Label basic key={keyNeed} style={{ margin: '4px 4px 4px 0' }}>
                {keyNeed}
              </Label>
            ))}
            <Separator height={16} transparent />
            {schoolBoard && (
              <>
                <Text variant="eyebrow2" color={COLORS.GRAY}>
                  School Board
                </Text>
                <Text variant="body1Medium">{schoolBoard}</Text>
              </>
            )}
          </Col>
        </AccordionContent>
      </Accordion>
    </Segment>
  );
};

export default Ecna;
